import styled from 'styled-components';

export const PriceDetailsStyle = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	height: 100dvh;
	width: 100%;
	overflow: auto;
	padding: 12px 28px 0 28px;

	.content {
		display: flex;
		flex-direction: column;
		gap: 24px;
		height: 100%;
	}

	.close-button {
		margin-left: auto;
	}
`;

export const HeaderStyle = styled.div`
	display: flex;
	flex-direction: column;
`;

export const OverviewStyle = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;

	.prices {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.rates {
		display: flex;
		flex-direction: column;
		gap: 12px;

		button {
			align-self: flex-start;
		}
	}
`;

export const SubtotalStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const ButtonsStyle = styled.div`
	position: sticky;
	bottom: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 12px;
	margin-top: auto;
	background: white;
	z-index: 10;
	padding-bottom: 12px;
	box-sizing: border-box;
`;

export const WebcalcContainer = styled.div`
	display: flex;
	flex-direction: column;
	dl:first-of-type {
		dt,
		dd {
			font-size: 12px;
			font-weight: 400;
			line-height: 20px;
		}
	}
`;
